import { AlertModal, Button, Text } from '@sixfold/common-ui';
import React from 'react';

interface Props {
  tokenLabel: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const OvdTokenDeleteDialog: React.FC<Props> = ({ tokenLabel, isDeleting, onConfirm, onCancel }) => {
  return (
    <AlertModal
      open
      onClose={onCancel}
      trigger={null}
      title="Delete OVD Token"
      description={
        <Text>
          Are you sure you want to delete the token <Text weight="bold">{tokenLabel || '(no label)'}</Text>? This action
          cannot be undone and any clients using this token will lose access to the data immediately.
        </Text>
      }>
      <Button kind="subtle" onClick={onCancel} disabled={isDeleting}>
        Cancel
      </Button>
      <Button kind="danger" onClick={onConfirm} disabled={isDeleting} loading={isDeleting}>
        Delete
      </Button>
    </AlertModal>
  );
};
